import React, { useState } from "react";
import { Box, Fade } from "@mui/material";

const TooltipInfo = ({ icon, content, ...props }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <Box>
      <Box
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        sx={{
          cursor: "pointer",
        }}
      >
        {icon}
      </Box>
      <Fade in={isTooltipVisible} timeout={300}>
        <Box
          sx={{
            position: "absolute",
            top: "30px",
            right: "15px",
            backgroundColor: "#fff",
            border: "1px solid #D0D5DE",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            maxWidth: 550,
            pointerEvents: "none",
            display: "block",
            ...props.sx,
          }}
        >
          {content}
        </Box>
      </Fade>
    </Box>
  );
};

export default TooltipInfo;
